import styled from '@emotion/styled';
import {
  TagInfo,
  TextHighlight,
  TextParagraph,
  token,
} from '@ferreri/prever-component-lib';

import { formatCentsMonetary } from '../../utils/formatCentsMonetary';

type PriceFirstMonthPlanProps = {
  price?: number;
  firstMonthPrice?: number;
  hasFirstMonthPrice?: boolean;
};

export const PriceFirstMonthPlan = (props: PriceFirstMonthPlanProps) => {
  return (
    <Wrapper>
      <PriceText
        price={props.price}
        firstMonthPrice={props.firstMonthPrice}
        hasFirstMonthPrice={props.hasFirstMonthPrice}
      />
      <DiscountText
        price={props.price}
        firstMonthPrice={props.firstMonthPrice}
        hasFirstMonthPrice={props.hasFirstMonthPrice}
      />
    </Wrapper>
  );
};

const PriceText = (props: PriceFirstMonthPlanProps) => {
  if (!props.price) return null;
  return (
    <TextBox>
      <TextParagraph>A partir de</TextParagraph>
      <TextHighlight>{`${formatCentsMonetary(props.price)}`}</TextHighlight>
    </TextBox>
  );
};

const DiscountText = (props: PriceFirstMonthPlanProps) => {
  if (!props.price) return null;
  if (props.hasFirstMonthPrice) {
    return (
      <TagInfo>{`${formatCentsMonetary(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        props.firstMonthPrice!,
      )} no primeiro mês`}</TagInfo>
    );
  }
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXxSmall};
`;

const TextBox = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXxxSmall};
`;
